import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import classNames from 'classnames';
import React, { useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import { useKeyNavigation } from '../common/effects/useKeyNavigation';
import { isDark } from '../common/utils';
import { withOverlay } from '../common/withOverlay';
import { MenuItem } from './menu-item';
import styles from './menu.module.scss';
const MenuContainer = React.forwardRef(({ items, onSelection, focusable, size = 'sm', dockPosition = 'left', hideArrow, RTL = false, }, ref) => {
    const listRef = useRef(null);
    const isDarkMode = useMemo(() => isDark(), []);
    /**
     * Handle key navigation
     */
    const { selection, setSelection } = useKeyNavigation(listRef, -1, items.length, 0, focusable);
    const menuClass = useMemo(() => classNames([styles.menu], {
        [styles[size]]: size,
        [styles[dockPosition]]: true,
        [styles.dark]: isDarkMode,
        [styles.arrow]: !hideArrow,
    }), [isDarkMode]);
    /**
     * Imperative handle for managing focus
     */
    useImperativeHandle(ref, () => {
        return {
            element: listRef.current,
            focus: () => {
                listRef.current?.focus();
            },
        };
    });
    /**
     * Sets the focus on the first item on load
     */
    useEffect(() => {
        if (focusable) {
            setSelection(0);
        }
    }, []);
    return (_jsx("ul", { className: menuClass, role: "menu", ref: listRef, tabIndex: 0, children: items.map(({ name, id, disabled }, index) => (_jsx(MenuItem, { name: name, disabled: disabled, handleSelection: onSelection, size: size, isDark: isDarkMode, RTL: RTL, focus: focusable
                ? selection > -1
                    ? selection === index
                    : index === 0
                : false }, id))) }));
});
MenuContainer.displayName = 'Menu';
const MenuOverlay = withOverlay(MenuContainer, {
    backdropColor: 'transparent',
    placement: 'bottom',
});
export { MenuOverlay };
